import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "./select";
import { useTheme } from "../theme-provider";

export const ThemeSelector = () => {
    const { theme, setTheme } = useTheme();

    return (
        <Select
            value={theme}
            onValueChange={(value: "light" | "dark" | "system") => {
                setTheme(value);
            }}
        >
            <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Select a theme" />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value="light">Light</SelectItem>
                <SelectItem value="dark">Dark</SelectItem>
                <SelectItem value="system">System</SelectItem>
            </SelectContent>
        </Select>
    );
}; 